<template>
  <base-info-card title="Post Categories">
    <ul class="pl">
      <li
        v-for="category in categories"
        :key="category.value"
        class="mb-3"
      >
        <router-link
          :to="{ name: 'BlogCategory', params: { lang: $i18n.locale, slug: category.value } }"
          class="category-link"
        >
          {{ category.label }}
        </router-link>
      </li>
    </ul>
  </base-info-card>
</template>

<script>
  export default {
    name: 'NewsCategories',

    data: () => ({
      categories: [],
    }),

    watch: {
      '$i18n.locale'() {
        this.loadCategories()
      },
    },

    async mounted() {
      await this.loadCategories()
    },

    methods: {
      async loadCategories() {
        try {
          const resp = await this.$axios({ method: 'get', url: '/public/dict/data', params: { dictType: 'sys_blog_category' } })
          const items = Array.isArray(resp) ? resp : (resp?.data || resp?.items || [])
          this.categories = items.map(item => ({
            label: item.dictLabel,
            value: item.dictValue,
          })).filter(item => item.label && item.value)
        } catch (error) {
          this.categories = []
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
.category-link
  color: inherit
  text-decoration: none

  &:hover
    color: #142d7a
    text-decoration: underline
</style>
